import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '@app/_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-history-modal',
  templateUrl: './history-modal.component.html',
  styleUrls: ['./history-modal.component.less']
})
export class HistoryModalComponent implements OnInit {
  @Input() entityType : any;
  @Input() entityId : any;
  @Input() title : any;
  historyLog: any;

  constructor(private commonServices : CommonService, private toastr : ToastrService, private modalService : NgbModal) { }

  ngOnInit(): void {
    this.getHistory();
  }

  getHistory(): void {
    const requestParams = {
      entityType: this.entityType,
      entityId: this.entityId,
    };
    this.commonServices.getHistoryLog(requestParams).subscribe((data: any) => {
      if (data.code === 200) {
        data.response.forEach((value: any) => {
          value.json = JSON.parse(value.json);
        });
        this.historyLog = data.response;
      } else {
        this.toastr.error(data.message);
      }
    });
  }

  close() {
    this.modalService.dismissAll();
  }
}
